import { Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatDialog, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { Subject, takeUntil } from 'rxjs';
import { ApiResponse, CamDeleteModel } from 'src/app/models/interface/CAM/baseResponseInterfaces';
import { PredefinedReason, ReasonRequest } from 'src/app/models/interface/CAM/TravellerInterface';
import { CamService } from 'src/app/services/camService/cam.service';
import { CryptoService } from 'src/app/services/commonService/crypto.service';
import { CompanyManagementService } from 'src/app/services/dataLayer/CAM/company-management.service';
import { CommonService } from 'src/app/shared/common/common.service';
import { ToastrApiService } from 'src/app/shared/common/toastr-api.service';
import { CompanyManagementContentService } from '../../services/company-management-content.service';
import { NgIf, NgFor, NgClass } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatRadioGroup, MatRadioButton } from '@angular/material/radio';
import { MatFormField, MatLabel, MatSuffix, MatError } from '@angular/material/form-field';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/autocomplete';
import { MatInput } from '@angular/material/input';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatButton } from '@angular/material/button';
import { MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { CamEmptyStateComponent } from '../cam-empty-state/cam-empty-state.component';
import { CdkScrollable } from '@angular/cdk/scrolling';

@Component({
    selector: 'app-pre-defined-reasons',
    templateUrl: './pre-defined-reasons.component.html',
    styleUrls: ['./pre-defined-reasons.component.scss'],
    imports: [ReactiveFormsModule, NgIf, MatIcon, MatRadioGroup, MatRadioButton, MatFormField, MatLabel, MatSuffix, MatSelect, NgFor, MatOption, MatError, MatInput, MatCheckbox, MatButton, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, NgClass, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, CamEmptyStateComponent, CdkScrollable, MatDialogContent, MatDialogActions]
})
export class PreDefinedReasonsComponent implements OnInit, OnDestroy {
  displayedColumns: string[] = ['Reason Code', 'Reason Name', 'Reason Type', 'Policy Flag', 'Status', 'Action'];
  Addnew: boolean = false;
  predefinedReasonForm!: FormGroup;
  selectedProducts: string[] = []; // To store selected products
  saUserId!: string;
  isLoading = true;
  isLangOpen: boolean = false;
  commonObjPipes: any = {
    GetAllCountryLanguage: { pipe: [], all: [] },
    GetAllPreDefinedReasonsDetails: { pipe: [], all: [] },
    ProductList: { pipe: [], all: [] },
  }
  @ViewChild('selectionWarning') selectionWarning!: TemplateRef<any>;
  currentItem: any;
  private destroy$=new Subject<void>();
  content:any;
  constructor(private _CamService: CamService, private fb: FormBuilder, private crypto: CryptoService, private dialog: MatDialog, private _ToastrApiService: ToastrApiService, public _CommonService: CommonService, private _CompanyManagementService: CompanyManagementService, private contentService:CompanyManagementContentService) {
    this.predefinedReasonForm = this.fb.group({
      flag: ['ADD'],
      reasonID: [null],
      reasonCode: ['', [Validators.required, Validators.maxLength(50)]],
      reasonName: ['', [Validators.required, Validators.maxLength(100), Validators.minLength(2)]],
      product: ['', [Validators.required]],
      languageCode: [null, [Validators.required]],
      reasonType: true,
      policyFlag: '',
      status: '',
      defaultLF: '',
      sauserid: [this.crypto.getValueFromKey('USERID') as string],
    })

  }

  ngOnInit(): void {
    this.contentService.content$.pipe(takeUntil(this.destroy$)).subscribe((res:any)=>{
      this.content = res;
    })
    this.saUserId = this.crypto.getValueFromKey('USERID') as string
    this.getPreDefinedReasonsList()
    this.loadInitialData()
  }

  addNewPredefinedReasons() {
    this.Addnew = true;
    // Reset selectedProducts array
    this.selectedProducts = [];
    this.predefinedReasonForm.reset({
      flag: 'ADD',
      reasonID: null,
      reasonCode: '',
      reasonName: '',
      product: '',
      languageCode: null,
      reasonType: true,
      policyFlag: '',
      status: '',
      defaultLF: '',
      sauserid: this.saUserId,
    });

    this._CompanyManagementService.company_management_predefinedReason('Add link','Add',this.commonObjPipes.GetAllPreDefinedReasonsDetails.pipe.length)//GTM use
  }



  handleEvent(event: string) {
    if (event.includes('pre-defined-reasons')) {
      this.Addnew = true;
    }
  }

  getPreDefinedReasonsList() {
    this.isLoading = true;
    this._CamService.getPredefinedReasons().then((res: ApiResponse<PredefinedReason[]>) => {

      // 🔥 Handle null API response
      // if (!res || res === null || !res.data || res.data === null) {

      //   this._ToastrApiService.show('error', 'No content available');
      //   return;
      // }

      if (res.status == "Success") {
        // this.bindLists('GetAllCountryLanguage', res.data.GetAllCountryLanguage)
        this.bindLists('GetAllPreDefinedReasonsDetails', res.data)
        // this.bindLists('ProductList', res.data.ProductList);
      }
    }).catch((error) => {
      console.error(error)
    }).finally(() => {
      this.isLoading = false;
    })
  }

  async loadInitialData() {
    try {
      this.isLoading = true;

      const [language, productList] = await Promise.all([
        // this._CamService.getPredefinedReasons(),
        this._CamService.getLanguage(),
        this._CamService.getProductList()
      ]);
      console.log('product list',productList);

      this.bindLists('GetAllCountryLanguage', language.data)
      // this.bindLists('GetAllPreDefinedReasonsDetails', preDefinedReason.data)
      this.bindLists('ProductList', productList.data);

    } catch (error: any) {
      const errMsg = error?.message || error?.error?.message || 'Something went wrong while fetching Data.';
      this._ToastrApiService.show('error', errMsg)
      this.isLoading = false;

    }
  }

  bindLists(key: string, lists: any[]) {
    this.commonObjPipes[key].pipe = lists;
    this.commonObjPipes[key].all = lists;
  }

  onCheckboxChange(event: any, product: string) {
    if (event.checked) {
      // Add product only if it does not already exist
      if (!this.selectedProducts.includes(product.trim())) {
        this.selectedProducts.push(product.trim());
      }
    } else {
      // Remove product if it exists
      this.selectedProducts = this.selectedProducts.filter(p => p !== product.trim());
    }

    // Update form control with the selected products as a comma-separated string
    this.predefinedReasonForm.controls['product'].setValue(this.selectedProducts.join(','));
    this.predefinedReasonForm.controls['product'].updateValueAndValidity();
  }


  onSave() {

    this._CompanyManagementService.company_management_predefinedReason('Save button','Save',this.commonObjPipes.GetAllPreDefinedReasonsDetails.pipe.length)//GTM use

    if (this.predefinedReasonForm.invalid) {
      return
    }

    const requestData: ReasonRequest = {
      flag: this.predefinedReasonForm.value.flag,
      reasonID: this.predefinedReasonForm.value.reasonID,
      reasonCode: this.predefinedReasonForm.value.reasonCode,
      reasonName: this.predefinedReasonForm.value.reasonName,
      product: this.predefinedReasonForm.value.product,
      languageCode: this.predefinedReasonForm.value.languageCode,
      reasonType: this.predefinedReasonForm.value.reasonType,
      policyFlag: this.predefinedReasonForm.value.policyFlag,
      status: this.predefinedReasonForm.value.status,
      defaultLF: this.predefinedReasonForm.value.defaultLF,
      sauserid: this.predefinedReasonForm.value.sauserid
    }

    this._CamService.insertUpdatePredefinedReasonsV1(requestData).then((res) => {

      if (!res) {
        this._ToastrApiService.show('error', 'No response received from server.');
        return;
      }

      // Handle API response
      switch (res.status) {
        case 'Created':
          this._ToastrApiService.show('success', res.message || 'Travel category created successfully.');
          this._CompanyManagementService.save_success('Prdefined reason', 'Success')//GTM use
          break;

        case 'Success':
          this._ToastrApiService.show('success', res.message || 'Travel category updated successfully.');
          this._CompanyManagementService.save_success('Prdefined reason', 'Success')//GTM use
          break;

        case 'Conflict':
          this._ToastrApiService.show('warning', res.message || 'Duplicate entry detected.');
          break;

        default:
          this._ToastrApiService.show('error', res.message || 'Unexpected response from server.');
          console.warn('Unhandled status:', res);
          break;
      }

      this.getPreDefinedReasonsList()
      this.Addnew = false;
      this._CommonService.formResetTrigger();

    }).catch((error) => {
      console.error(error)
      const errorMessage =
        error?.error?.message ||
        error?.message ||
        'Something went wrong while saving the predefined reason. Please try again later.';
      this._ToastrApiService.show('error', errorMessage);
    })

  }

  onCancel() {
    this.Addnew = false;
    this._CompanyManagementService.company_management_predefinedReason('Cancel button','Cancel',this.commonObjPipes.GetAllPreDefinedReasonsDetails.pipe.length)//GTM use


  }

  onEdit(item: PredefinedReason) {
    this.Addnew = true;
    this._CompanyManagementService.company_management_predefinedReason('Edit button','Edit',this.commonObjPipes.GetAllPreDefinedReasonsDetails.pipe.length)//GTM use

    // Convert Product_Code string into an array
    this.selectedProducts = item.productCode ? item.productCode.split(',').map((p: string) => p.trim()) : [];
    this.predefinedReasonForm.patchValue({
      flag: 'UPDATE',
      reasonID: item.reasonId,
      reasonCode: item.reasonCode,
      reasonName: item.reasonName,
      product: this.selectedProducts.join(','),  // Set the joined string value for form control
      languageCode: item.languageCode,
      reasonType: item.reasonType,
      policyFlag: item.policyFlag,
      status: item.status,
      defaultLF: item.defaultLowestFare,
      sauserid: this.saUserId,
    });


  }


  onRemove(item: PredefinedReason) {
    this.currentItem = item;
    const dialogRef = this.dialog.open(this.selectionWarning, {
      data: item, // Pass the item data
    });
    this._CompanyManagementService.company_management_predefinedReason('Remove button','Remove',this.commonObjPipes.GetAllPreDefinedReasonsDetails.pipe.length)//GTM use

  }

  confirmDelete(item: PredefinedReason) {

    const request: CamDeleteModel = {
      id: item.reasonId,
      type: 'REASON'
    }

    this._CamService.DeleteCAMitemBytype(request).then((res) => {
      if (res.status == "Success") {
        this._ToastrApiService.show('success', res.message);
        this.currentItem = undefined;
        this.getPreDefinedReasonsList();
        this._CompanyManagementService.predefinedReason_Successfully('Remove','Success')//GTM use
      }
    }).catch((error) => {
      const errorMessage =
        error?.error?.message ||
        error?.message ||
        'Something went wrong while deleting the Pre defined reasons. Please try again later.';
      this._ToastrApiService.show('error', errorMessage);
    })
  }

  CloseDialog(result: boolean) {
    if (result) {
      this.confirmDelete(this.currentItem)
      this._CompanyManagementService.predefinedReason_remove('Proceed','Are you sure you want to remove this Pre defined reasons?')//GTM use
    }

    if(!result){
      this._CompanyManagementService.predefinedReason_remove('Cancel','Are you sure you want to remove this Pre defined reasons?')//GTM use
    }

    this.dialog.closeAll(); // Closes the dialog
  }


  disableRightClick(event: MouseEvent): void {
    event.preventDefault();
  }

  onPasteBlocked(event: ClipboardEvent): void {
    event.preventDefault(); // Prevent the paste action
  }

  blockInvalidCharacters1(event: KeyboardEvent): void {
    // List of invalid characters that can be used for XSS, SQL injection, or path traversal
    const invalidChars = ['<', '>', '"', "'", '`', ';', ':', '$', '|', '[', ']', '~', '--', '@', '\\', '?', '+', '_', '#', '%', '^', '*', '!', '=', '%', '(', ')', '{', '}',];

    // If the pressed key is in the invalidChars array, prevent the input
    if (invalidChars.includes(event.key)) {
      event.preventDefault(); // Block the invalid character
    }
  }
  ngOnDestroy(){
    this.destroy$.next();
    this.destroy$.complete();
  }

}

